import React from 'react';
import { motion } from 'framer-motion';

const Introduction = () => {
  return (
    <section className="prose prose-invert max-w-none">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <h2 className="text-3xl font-bold mb-6">The Journey of Animatronic Innovation</h2>
        <p className="text-xl leading-relaxed">
          Animatronics—the art and science of creating lifelike mechanical figures—has thrilled audiences for generations. Whether you're chatting with a talking trash can in Tomorrowland or staring down a massive dragon in a touring exhibition, animatronics brings imagination to life.
The Animatronic Database spotlights those installations in theme parks, exhibitions, restaurants, museums, aquariums, and other facets of the themed entertainment industry. Below, we celebrate how animatronics have grown, where the industry stands today, and where it's headed.

        </p>
      </motion.div>
    </section>
  );
}

export default Introduction;